<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.close' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>
      @if (formGroup.get('guid').value) {
        {{ 'notes.edit' | translate }}
      } @else {
        {{ 'notes.add' | translate }}
      }
    </h2>
  </div>

  <section class="note-modal">
    @if (!formGroup.get('guid').value && site()) {
      <div class="note-modal__context">
        <strong>{{ site().name }}</strong>
        <p>{{ 'notes.siteInfo' | translate }}</p>
      </div>
    }

    @if (!formGroup.get('guid').value) {
      <app-segment-list [segmentValue]="viewSegment()"
        [segmentButtons]="viewSegmentButtons"
        (segmentChanged)="viewSegment.set($event)"></app-segment-list>
    }

    <form class="note-modal__form"
      [formGroup]="formGroup">
      @if (viewSegment() === 'text') {
        <app-report-note [text]="noteText()"></app-report-note>
      } @else {
        <ion-item lines="none"
          class="note-modal__textarea-item">
          <ion-textarea autocapitalize="on"
            rows="10"
            formControlName="text"></ion-textarea>
        </ion-item>
      }
    </form>
  </section>

  <div modalFooter
    class="note-modal__footer">
    <button class="note-modal__button note-modal__button--secondary"
      type="button"
      (click)="dismiss()">
      {{ 'general.cancel' | translate }}
    </button>

    @if (viewSegment() === 'ai') {
      <button class="note-modal__button note-modal__button--primary"
        type="button"
        [disabled]="!formGroup.valid"
        (click)="onAi()">
        <app-loading-button [loading]="loading()">
          {{ 'general.next' | translate }}
        </app-loading-button>
      </button>
    } @else {
      @if (formGroup.get('guid').value) {
        <button class="note-modal__button note-modal__button--secondary"
          type="button"
          (click)="print()">
          {{ 'general.print' | translate }}
        </button>
      }
      <button class="note-modal__button note-modal__button--primary"
        type="button"
        (click)="save()">
        <app-loading-button [loading]="loading()">
          {{ 'general.save' | translate }}
        </app-loading-button>
      </button>
    }
  </div>
</app-modal-shell>